var path = 'src/app/components/common/pdf-view/pdf-view.template.html';
var html = "<div class=\"pdf-view\">\n  <figure class=\"pdf-view__container\">\n    <iframe class=\"pdf-view__document\" src=\"{{$ctrl.trustedSourceUrl}}\"></iframe>\n  </figure>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;